var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_336",
    "data-name": "Grupo 336",
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.197,
    height: 110.823,
    viewBox: "0 0 158.197 110.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_56",
    "data-name": "Grupo 56",
    transform: "translate(0 83.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_55",
    "data-name": "Grupo 55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_207",
    "data-name": "Caminho 207",
    d: "M476.817,258.066v11.088h-1.332V266.8a5.267,5.267,0,0,1-1.985,1.828,6.016,6.016,0,0,1-5.771.029,5.294,5.294,0,0,1-2.041-2.042,6.564,6.564,0,0,1,.028-6.153,5.24,5.24,0,0,1,2.155-2.028,6.679,6.679,0,0,1,3.1-.709,4.923,4.923,0,0,1,2.609.765,5.177,5.177,0,0,1,1.9,1.985l.141-2.41Zm-2.75,9.017a4.183,4.183,0,0,0,1.418-2.978v-1.588a4.515,4.515,0,0,0-1.645-2.609,4.625,4.625,0,0,0-2.978-1.049,4.725,4.725,0,0,0-2.325.581,4.269,4.269,0,0,0-1.659,1.646,4.837,4.837,0,0,0-.609,2.452,4.621,4.621,0,0,0,.623,2.354,4.74,4.74,0,0,0,1.688,1.715,4.405,4.405,0,0,0,2.31.638A4.6,4.6,0,0,0,474.067,267.084Z",
    transform: "translate(-464.936 -247.177)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_208",
    "data-name": "Caminho 208",
    d: "M484.906,252.4v5.019h3.431v1.078h-3.431v9.869h-1.361v-9.869h-2.354v-1.078h2.354V252.4Z",
    transform: "translate(-467.354 -246.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_209",
    "data-name": "Caminho 209",
    d: "M492.651,245.834v21.551h-1.333V245.834Z",
    transform: "translate(-468.86 -245.408)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_210",
    "data-name": "Caminho 210",
    d: "M507.263,256.858v11.088h-1.332v-2.354a5.273,5.273,0,0,1-1.985,1.828,6.015,6.015,0,0,1-5.771.029,5.294,5.294,0,0,1-2.041-2.042,6.563,6.563,0,0,1,.028-6.153,5.233,5.233,0,0,1,2.155-2.028,6.674,6.674,0,0,1,3.1-.709,4.922,4.922,0,0,1,2.609.765,5.184,5.184,0,0,1,1.9,1.985l.141-2.41Zm-2.75,9.017a4.183,4.183,0,0,0,1.418-2.978V261.31a4.511,4.511,0,0,0-1.645-2.609,4.621,4.621,0,0,0-2.977-1.049,4.727,4.727,0,0,0-2.326.581,4.272,4.272,0,0,0-1.658,1.645,4.837,4.837,0,0,0-.61,2.452,4.613,4.613,0,0,0,.624,2.354,4.74,4.74,0,0,0,1.688,1.715,4.4,4.4,0,0,0,2.31.638A4.6,4.6,0,0,0,504.513,265.875Zm.341-11.768-2.836-3.176-2.779,3.176h-1.333l4.112-4.509h.029l4.14,4.509Z",
    transform: "translate(-469.465 -245.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_211",
    "data-name": "Caminho 211",
    d: "M521.553,258.681a3.357,3.357,0,0,1,1.021,2.4v8.082h-1.361v-7.713a2.742,2.742,0,0,0-.709-1.8,2.532,2.532,0,0,0-1.871-.724,4.127,4.127,0,0,0-3.615,2.056,4.268,4.268,0,0,0-.582,2.226v5.955H513.1V258.071h1.163l.113,2.467a4.211,4.211,0,0,1,1.828-2.028,5.564,5.564,0,0,1,2.85-.752A3.462,3.462,0,0,1,521.553,258.681Z",
    transform: "translate(-472.1 -247.182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_212",
    "data-name": "Caminho 212",
    d: "M530.242,252.4v5.019h3.431v1.078h-3.431v9.869h-1.361v-9.869h-2.354v-1.078h2.354V252.4Z",
    transform: "translate(-474.097 -246.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_213",
    "data-name": "Caminho 213",
    d: "M537.97,257.277v11.088h-1.333V257.277Zm-.047-4.856h-1.182a.2.2,0,0,0-.2.2V253.8a.2.2,0,0,0,.2.2h1.182a.2.2,0,0,0,.2-.2v-1.181A.2.2,0,0,0,537.923,252.421Z",
    transform: "translate(-475.587 -246.388)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_214",
    "data-name": "Caminho 214",
    d: "M548.614,269.055a6.279,6.279,0,0,1-5.019-.411,5.482,5.482,0,0,1-2.112-2.069,5.79,5.79,0,0,1-.766-2.963,5.712,5.712,0,0,1,.78-2.964,5.628,5.628,0,0,1,2.113-2.069,5.8,5.8,0,0,1,2.893-.752,5.921,5.921,0,0,1,3.884,1.3l-.708.907a4.921,4.921,0,0,0-3.091-1.106,4.343,4.343,0,0,0-2.283.624,4.582,4.582,0,0,0-1.645,1.7,4.693,4.693,0,0,0-.609,2.354,4.617,4.617,0,0,0,.609,2.339,4.588,4.588,0,0,0,4.041,2.311,4.786,4.786,0,0,0,2.921-.993l.737.822A5.7,5.7,0,0,1,548.614,269.055Z",
    transform: "translate(-476.208 -247.192)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_215",
    "data-name": "Caminho 215",
    d: "M553.756,260.6a5.716,5.716,0,0,1,2.141-2.126,6.183,6.183,0,0,1,6.012,0,5.6,5.6,0,0,1,2.126,2.126,5.837,5.837,0,0,1,.766,2.935,5.77,5.77,0,0,1-2.907,5.062,5.914,5.914,0,0,1-3.019.78,6.085,6.085,0,0,1-3.02-.752,5.456,5.456,0,0,1-2.113-2.084,5.929,5.929,0,0,1-.765-3.006A5.754,5.754,0,0,1,553.756,260.6Zm1.163,5.317a4.548,4.548,0,0,0,1.659,1.7,4.539,4.539,0,0,0,4.594,0,4.553,4.553,0,0,0,1.658-1.7,4.694,4.694,0,0,0,.61-2.354,4.772,4.772,0,0,0-.61-2.367,4.525,4.525,0,0,0-1.658-1.716,4.418,4.418,0,0,0-2.3-.623,4.246,4.246,0,0,0-2.326.667,4.763,4.763,0,0,0-1.645,1.743,4.79,4.79,0,0,0,.014,4.65Z",
    transform: "translate(-478.031 -247.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_216",
    "data-name": "Caminho 216",
    d: "M568.45,269.169a.9.9,0,0,1,.652-.284.947.947,0,0,1,.667.284.927.927,0,0,1,0,1.36.944.944,0,0,1-.667.284.963.963,0,0,1-.652-1.645Z",
    transform: "translate(-480.29 -248.837)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_217",
    "data-name": "Caminho 217",
    d: "M584.5,245.334v21.977h-2.665v-1.844a6.007,6.007,0,0,1-2.085,1.56,6.4,6.4,0,0,1-2.708.568,5.715,5.715,0,0,1-2.978-.794,5.505,5.505,0,0,1-2.084-2.226,7,7,0,0,1-.752-3.3,6.6,6.6,0,0,1,.794-3.3,5.335,5.335,0,0,1,2.183-2.141,6.6,6.6,0,0,1,3.147-.738,6.209,6.209,0,0,1,2.566.553,4.775,4.775,0,0,1,1.943,1.517V245.334ZM580.46,264.5a3.735,3.735,0,0,0,1.376-2.212V260.08A3.707,3.707,0,0,0,580.39,258a4.169,4.169,0,0,0-2.524-.808,3.93,3.93,0,0,0-3.431,1.971,4.267,4.267,0,0,0,0,4.154,4,4,0,0,0,1.445,1.474,3.818,3.818,0,0,0,1.985.539A4.114,4.114,0,0,0,580.46,264.5Z",
    transform: "translate(-480.746 -245.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_218",
    "data-name": "Caminho 218",
    d: "M592.654,256.443v11.74h-2.637v-11.74Zm-.328-5.247h-1.98a.329.329,0,0,0-.329.329V253.5a.328.328,0,0,0,.329.329h1.98a.328.328,0,0,0,.328-.329v-1.979A.329.329,0,0,0,592.326,251.2Z",
    transform: "translate(-483.541 -246.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_219",
    "data-name": "Caminho 219",
    d: "M608.559,257.276V269.1a5.367,5.367,0,0,1-.822,2.922,5.759,5.759,0,0,1-2.34,2.069,7.8,7.8,0,0,1-3.558.766,7.294,7.294,0,0,1-3.076-.6,10.65,10.65,0,0,1-2.595-1.758l1.56-1.815a7.872,7.872,0,0,0,1.928,1.376,4.81,4.81,0,0,0,2.126.467,4.426,4.426,0,0,0,3.02-.936,3.274,3.274,0,0,0,1.091-2.524l.029-2.212a4.712,4.712,0,0,1-1.915,1.772,6.138,6.138,0,0,1-2.906.667,5.652,5.652,0,0,1-2.978-.822,6.089,6.089,0,0,1-2.169-2.241,6.573,6.573,0,0,1,.028-6.366,6.148,6.148,0,0,1,2.255-2.255,5.955,5.955,0,0,1,3.034-.822,6.491,6.491,0,0,1,2.778.6,4.48,4.48,0,0,1,1.9,1.531l.2-1.645Zm-4.083,9.017a3.778,3.778,0,0,0,1.446-2.155v-2.325a3.863,3.863,0,0,0-1.5-2.057,4.32,4.32,0,0,0-2.552-.78,3.978,3.978,0,0,0-2.892,1.135A3.865,3.865,0,0,0,597.812,263a4.073,4.073,0,0,0,2.013,3.558,3.941,3.941,0,0,0,2.041.553A4.252,4.252,0,0,0,604.476,266.293Z",
    transform: "translate(-484.304 -247.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_220",
    "data-name": "Caminho 220",
    d: "M616.771,256.443v11.74h-2.637v-11.74Zm-.329-5.247h-1.98a.33.33,0,0,0-.329.329V253.5a.329.329,0,0,0,.329.329h1.98a.329.329,0,0,0,.329-.329v-1.979A.329.329,0,0,0,616.443,251.2Z",
    transform: "translate(-487.128 -246.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_221",
    "data-name": "Caminho 221",
    d: "M624.085,251.3v5.189h3.2v2.1h-3.2V268.2h-2.666v-9.613h-2.155v-2.1h2.155V251.3Z",
    transform: "translate(-487.891 -246.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_222",
    "data-name": "Caminho 222",
    d: "M642.163,257.276v11.74h-2.637v-1.929a6.071,6.071,0,0,1-1.815,1.517,5.249,5.249,0,0,1-2.693.7,6.273,6.273,0,0,1-3.02-.724,5.259,5.259,0,0,1-2.127-2.112,7.418,7.418,0,0,1,.029-6.678,5.708,5.708,0,0,1,2.184-2.212,6.076,6.076,0,0,1,3.048-.78,5.041,5.041,0,0,1,2.608.653,5.319,5.319,0,0,1,1.787,1.7l.2-1.871Zm-3.956,9.031a3.6,3.6,0,0,0,1.318-2.2v-2.326a3.621,3.621,0,0,0-1.418-2.028,4.1,4.1,0,0,0-2.467-.78,3.847,3.847,0,0,0-1.943.511,3.755,3.755,0,0,0-1.417,1.432,4.13,4.13,0,0,0-.524,2.085,4.062,4.062,0,0,0,.539,2.069,4.109,4.109,0,0,0,1.445,1.489,3.745,3.745,0,0,0,1.985.553A3.911,3.911,0,0,0,638.207,266.307Z",
    transform: "translate(-489.352 -247.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_223",
    "data-name": "Caminho 223",
    d: "M650.314,245.334v21.977h-2.637V245.334Z",
    transform: "translate(-492.117 -245.334)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57",
    "data-name": "Grupo 57",
    transform: "translate(46.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_224",
    "data-name": "Caminho 224",
    d: "M584.113,147.826H576.95a1.19,1.19,0,0,0-1.189,1.192v7.16a1.19,1.19,0,0,0,1.189,1.192h7.162a1.19,1.19,0,0,0,1.189-1.192v-7.16A1.191,1.191,0,0,0,584.113,147.826Z",
    transform: "translate(-528.051 -147.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_225",
    "data-name": "Caminho 225",
    d: "M575.776,164.639h-7.162a1.191,1.191,0,0,0-1.189,1.193v6.1a28.5,28.5,0,0,0-16.675-7.191q-1.19-.1-2.409-.1-1.186,0-2.35.1a28.628,28.628,0,0,0-.06,57.057q1.19.1,2.41.1c.79,0,1.575-.032,2.35-.1a28.5,28.5,0,0,0,16.735-7.2v6.1a1.191,1.191,0,0,0,1.189,1.193h7.162a1.191,1.191,0,0,0,1.189-1.193V165.832A1.191,1.191,0,0,0,575.776,164.639ZM550.69,212.207a19.31,19.31,0,0,1-2.321.142h-.028a19.552,19.552,0,0,1-2.41-.148,19.083,19.083,0,0,1,2.41-38.017h.037a20.31,20.31,0,0,1,2.372.148,19.087,19.087,0,0,1-.06,37.875Z",
    transform: "translate(-519.715 -150.327)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_226",
    "data-name": "Caminho 226",
    d: "M575.761,219.6v6.075c.515-.358,1.022-.73,1.514-1.117a33.6,33.6,0,0,0,8.026-9.082V198.27A28.538,28.538,0,0,1,575.761,219.6Z",
    transform: "translate(-528.051 -155.329)",
    fill: "#ccc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2c860f3598ae5cc43bf4e2d3895e9485.svg";
export { ForwardRef as ReactComponent };